import { graphql } from 'relay-runtime';

export const UPDATE_TRANSACTION_PRIMARY_MUTATION = graphql`
  mutation UpdateTransactionPrimaryMutation($token: String!, $aaid: String!) {
    unified {
      linking {
        updateLinkingWithPrimaryAccountAaid(aaid: $aaid, token: $token) {
          message
          success
          errors {
            extensions {
              errorType
              statusCode
            }
            code
            message
          }
        }
      }
    }
  }
`;
